import { getGiftCardTermsofUse, InfoPageModel } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import TermsPage from "components/Texts/TermsPage"
import { GetStaticProps } from "next"
import { useState } from "react"

type TermsStaticProps = {
  data: InfoPageModel
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<TermsStaticProps> = async () => {
  const { data } = await getGiftCardTermsofUse()

  const seo = {
    title: data?.body?.pageTitle,
    description: data?.body?.metaDescription,
    keywords: data?.body?.keywords,
  }
  return {
    props: { data: data?.body, seo },
    revalidate: 60,
  }
}

const Terms = ({ data, seo }: TermsStaticProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [refList, setRefList] = useState([])
  return (
    <>
      {/* removed KeyboardNavigation according to the accessibility consultant */}
      {/* <KeyboardNavigation refList={refList} /> */}
      <SeoMetaData data={seo} />
      <TermsPage data={data} setRefList={setRefList} />
    </>
  )
}

export default Terms
